import { render, staticRenderFns } from "./InvoicePage.vue?vue&type=template&id=2c7cdf81&"
import script from "./InvoicePage.vue?vue&type=script&lang=js&"
export * from "./InvoicePage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports